import servicio from "./axiosServices";

export function obtenerLastVideos() {
  return servicio.get(
    "https://www.googleapis.com/youtube/v3/search?key=AIzaSyCI8aLDyhaKrbgPgeQy9l9wVqdcS7VCO_U&channelId=UCPtGj6E0jEQXbpkkgMbUlbQ&part=snippet&order=date&maxResults=6"
  );
}

export function obtenerPlayList() {
  return servicio.get(
    "https://www.googleapis.com/youtube/v3/playlists?key=AIzaSyCI8aLDyhaKrbgPgeQy9l9wVqdcS7VCO_U&channelId=UCPtGj6E0jEQXbpkkgMbUlbQ&part=snippet,contentDetails&maxResults=20"
  );
}

export function obtenerPlayListVideo(listaId) {
  return servicio.get(
    "https://www.googleapis.com/youtube/v3/playlistItems?key=AIzaSyCI8aLDyhaKrbgPgeQy9l9wVqdcS7VCO_U&channelId=UCPtGj6E0jEQXbpkkgMbUlbQ&part=snippet,contentDetails&maxResults=20&playlistId=" +
      listaId
  );
}
